/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useLayoutEffect, useRef, useState} from 'react';
import { clearSearchFilters } from '../../../../../reduxToolkit/Search/SearchSlice';
import {
    SearchByFilters,
    SearchByFiltersCustom,
    SimpleSearch,
    SimpleSearchWithId
} from '../../../../../reduxToolkit/Search/SearchApi';
import {CRITERIA_MODEL, SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {useNavigate} from "react-router-dom";
import routes from "../../../../../Routes/routes";
import TableFunction from "../../../../../components/table/TableFunction";

const MainVehiclesCardsApp = ({
    view,
    selectedList,
    setSelectedList,
    option,
    setBodyForExport,
    searchElement,
    finalArray,
    setIsAllChecked,
    setCriteria,
    modified,
    setModified
}) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const navigate = useNavigate();
    const elementRef = useRef(null);
    const [results, setResults] = useState({ content: [], totalElements: 0 });

    useLayoutEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, []);

    const handleOnClick = (contractorId, supplierId, item) => {
        const id = item?.vehicleId || item?.id;
        if (contractorId) {
            navigate(item?.periodId ? `${routes.contractor.vehicleDocumentation}${id}`
                : `${routes.vehicleContractor.update}${id}`
            );
        } else if (supplierId) {
            navigate(item?.periodId ? `${routes.suppliers.vehicleDocumentation}${id}`
                : `${routes.vehicleSupplier.update}${id}`
            );
        } else {
            navigate(
                `${routes.vehicleFleet.update}${id}`
            );
        }
    }

    // Effect to handle component initialization and view updates
    useEffect(() => {
        dispatch(clearSearchFilters());
        if (elementRef.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 0;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    /** Executes a paginated search request using basic criteria.
    *
    * Builds the request body with the current page, page size, selected model,
    * and any additional criteria passed as arguments.
    * Triggers the search action through Redux and updates the results on success.
    */
    const getData = (page) => {
        const userId = contractorId ?? supplierId ?? null;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            view,
            key: searchElement,
            model: option,
            ...(userId && { userId }),
        });
        setBodyForExport(body);
        const action = userId ? SimpleSearchWithId : SimpleSearch;
        dispatch(action({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setResults(data);
        });
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const userId = contractorId ?? supplierId ?? null;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            view,
            ...(userId && { userToFindId: userId }),
        });
        setCriteria(body);
        const action = userId ? SearchByFiltersCustom : SearchByFilters;
        dispatch(action({ option, body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setResults(data);
        });
    }

    const {
        t,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        labelRowsPerPage: 'vehicle_per_page',
        setIsAllChecked,
        view,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });


    return {
        t,
        DEV,
        permission,
        contractorId,
        supplierId,
        results,
        setResults,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        elementRef,
        handleOnClick,
        navigate

    }

}

export default MainVehiclesCardsApp;
